<template>
  <div class="BarTwo"></div>
</template>

<script>
var timerId;
import { reqActileList } from "@/network/homePage";
export default {
  name: "BarTwo",
  methods: {
    async getInitData(type=3) {
      let { data } = await reqActileList({type:type});
      if (data.code == 200) {
        var companyData = [];
        var totalList = [];
        data.data.sort((a, b) => {
          return a.total - b.total;
        });

        for (const item of data.data) {
          companyData.push(item.name);
          totalList.push(item.total);
        }
      }
      this.$echarts.bartwo(this.myChart, {
        companyData,
        totalList,
      });
    },
	clickSelect(val){
		
		this.getInitData(parseInt(val))
	}
  },
  watch: {
    "$store.state.opened"() {
      if (timerId) {
        // console.log(timerId);
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        this.myChart.resize();
      }, 300);
    },
  },
  mounted() {
    this.myChart = this.$init(document.querySelector(".BarTwo"));
    this.getInitData();
  },
};
</script>
<style lang="scss" scoped>
.BarTwo {
  width: 100%;
  height: 100%;
}
</style>
